<div class="bg-[#0d3576] flex flex-col h-screen items-center justify-center">
  <div
    class="mt-7 bg-white border border-gray-200 rounded-xl shadow-2xs  max-w-2xl mx-auto p-6">
    <div class="p-4 sm:p-7">


      <div class="text-center">
        <img class="rounded-xl w-[50%] mx-auto" src="images/logo2.png" alt="Avatar">
      </div>



      <div class="text-center">
        <h1 class="block text-2xl font-bold text-gray-800">CIMS APPLICATION</h1>
        <p class="mt-2 text-sm text-gray-600">
          A Product of Stanbic Bank
        </p>
      </div>

      <div class="mt-8">
        <!-- Form -->
        <form>
          <div class="grid gap-y-6">
            <button type="button" (click)="handleSignIn($event)"
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-lg font-medium rounded-lg border border-transparent bg-[#0d3576] text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">SIGN
              IN</button>
          </div>
        </form>
        <!-- End Form -->
      </div>
    </div>
  </div>
</div>